module.exports = __webpack_public_path__ + "media/images/loading_animation-889ce220426261ae02adcfe3491bfaa2.gif";